import { useEffect as N, useContext as qe, useState as G, useRef as De, createContext as Le } from "react";
import { g as Ce } from "./_commonjsHelpers-DaMA6jEr.js";
var K = {}, me;
function ke() {
  if (me) return K;
  me = 1, K.match = s, K.parse = d;
  var e = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, a = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, u = /^(?:(min|max)-)?(.+)/, i = /(em|rem|px|cm|mm|in|pt|pc)?$/, f = /(dpi|dpcm|dppx)?$/;
  function s(l, c) {
    return d(l).some(function(m) {
      var g = m.inverse, j = m.type === "all" || c.type === m.type;
      if (j && g || !(j || g))
        return !1;
      var A = m.expressions.every(function($) {
        var q = $.feature, k = $.modifier, R = $.value, x = c[q];
        if (!x)
          return !1;
        switch (q) {
          case "orientation":
          case "scan":
            return x.toLowerCase() === R.toLowerCase();
          case "width":
          case "height":
          case "device-width":
          case "device-height":
            R = w(R), x = w(x);
            break;
          case "resolution":
            R = v(R), x = v(x);
            break;
          case "aspect-ratio":
          case "device-aspect-ratio":
          case /* Deprecated */
          "device-pixel-ratio":
            R = p(R), x = p(x);
            break;
          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            R = parseInt(R, 10) || 1, x = parseInt(x, 10) || 0;
            break;
        }
        switch (k) {
          case "min":
            return x >= R;
          case "max":
            return x <= R;
          default:
            return x === R;
        }
      });
      return A && !g || !A && g;
    });
  }
  function d(l) {
    return l.split(",").map(function(c) {
      c = c.trim();
      var m = c.match(e), g = m[1], j = m[2], A = m[3] || "", $ = {};
      return $.inverse = !!g && g.toLowerCase() === "not", $.type = j ? j.toLowerCase() : "all", A = A.match(/\([^\)]+\)/g) || [], $.expressions = A.map(function(q) {
        var k = q.match(a), R = k[1].toLowerCase().match(u);
        return {
          modifier: R[1],
          feature: R[2],
          value: k[2]
        };
      }), $;
    });
  }
  function p(l) {
    var c = Number(l), m;
    return c || (m = l.match(/^(\d+)\s*\/\s*(\d+)$/), c = m[1] / m[2]), c;
  }
  function v(l) {
    var c = parseFloat(l), m = String(l).match(f)[1];
    switch (m) {
      case "dpcm":
        return c / 2.54;
      case "dppx":
        return c * 96;
      default:
        return c;
    }
  }
  function w(l) {
    var c = parseFloat(l), m = String(l).match(i)[1];
    switch (m) {
      case "em":
        return c * 16;
      case "rem":
        return c * 16;
      case "cm":
        return c * 96 / 2.54;
      case "mm":
        return c * 96 / 2.54 / 10;
      case "in":
        return c * 96;
      case "pt":
        return c * 72;
      case "pc":
        return c * 72 / 12;
      default:
        return c;
    }
  }
  return K;
}
var ie, he;
function Ye() {
  if (he) return ie;
  he = 1;
  var e = ke().match, a = typeof window < "u" ? window.matchMedia : null;
  function u(f, s, d) {
    var p = this, v;
    a && !d && (v = a.call(window, f)), v ? (this.matches = v.matches, this.media = v.media, v.addListener(c)) : (this.matches = e(f, s), this.media = f), this.addListener = w, this.removeListener = l, this.dispose = m;
    function w(g) {
      v && v.addListener(g);
    }
    function l(g) {
      v && v.removeListener(g);
    }
    function c(g) {
      p.matches = g.matches, p.media = g.media;
    }
    function m() {
      v && v.removeListener(c);
    }
  }
  function i(f, s, d) {
    return new u(f, s, d);
  }
  return ie = i, ie;
}
var We = Ye();
const Ue = /* @__PURE__ */ Ce(We);
var Fe = /[A-Z]/g, Ne = /^ms-/, se = {};
function ze(e) {
  return "-" + e.toLowerCase();
}
function Me(e) {
  if (se.hasOwnProperty(e))
    return se[e];
  var a = e.replace(Fe, ze);
  return se[e] = Ne.test(a) ? "-" + a : a;
}
function He(e, a) {
  if (e === a)
    return !0;
  if (!e || !a)
    return !1;
  const u = Object.keys(e), i = Object.keys(a), f = u.length;
  if (i.length !== f)
    return !1;
  for (let s = 0; s < f; s++) {
    const d = u[s];
    if (e[d] !== a[d] || !Object.prototype.hasOwnProperty.call(a, d))
      return !1;
  }
  return !0;
}
var J = { exports: {} }, X = { exports: {} }, C = {};
var be;
function Qe() {
  if (be) return C;
  be = 1;
  var e = typeof Symbol == "function" && Symbol.for, a = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, u = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, i = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, f = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, s = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, d = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, p = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, v = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, w = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, l = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, c = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, m = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, g = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, j = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, A = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, $ = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, q = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, k = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function R(n) {
    if (typeof n == "object" && n !== null) {
      var U = n.$$typeof;
      switch (U) {
        case a:
          switch (n = n.type, n) {
            case v:
            case w:
            case i:
            case s:
            case f:
            case c:
              return n;
            default:
              switch (n = n && n.$$typeof, n) {
                case p:
                case l:
                case j:
                case g:
                case d:
                  return n;
                default:
                  return U;
              }
          }
        case u:
          return U;
      }
    }
  }
  function x(n) {
    return R(n) === w;
  }
  return C.AsyncMode = v, C.ConcurrentMode = w, C.ContextConsumer = p, C.ContextProvider = d, C.Element = a, C.ForwardRef = l, C.Fragment = i, C.Lazy = j, C.Memo = g, C.Portal = u, C.Profiler = s, C.StrictMode = f, C.Suspense = c, C.isAsyncMode = function(n) {
    return x(n) || R(n) === v;
  }, C.isConcurrentMode = x, C.isContextConsumer = function(n) {
    return R(n) === p;
  }, C.isContextProvider = function(n) {
    return R(n) === d;
  }, C.isElement = function(n) {
    return typeof n == "object" && n !== null && n.$$typeof === a;
  }, C.isForwardRef = function(n) {
    return R(n) === l;
  }, C.isFragment = function(n) {
    return R(n) === i;
  }, C.isLazy = function(n) {
    return R(n) === j;
  }, C.isMemo = function(n) {
    return R(n) === g;
  }, C.isPortal = function(n) {
    return R(n) === u;
  }, C.isProfiler = function(n) {
    return R(n) === s;
  }, C.isStrictMode = function(n) {
    return R(n) === f;
  }, C.isSuspense = function(n) {
    return R(n) === c;
  }, C.isValidElementType = function(n) {
    return typeof n == "string" || typeof n == "function" || n === i || n === w || n === s || n === f || n === c || n === m || typeof n == "object" && n !== null && (n.$$typeof === j || n.$$typeof === g || n.$$typeof === d || n.$$typeof === p || n.$$typeof === l || n.$$typeof === $ || n.$$typeof === q || n.$$typeof === k || n.$$typeof === A);
  }, C.typeOf = R, C;
}
var M = {};
var Ee;
function Ve() {
  return Ee || (Ee = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, a = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, u = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, i = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, f = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, s = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, d = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, p = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, v = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, w = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, l = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, c = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, m = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, g = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, j = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, A = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, $ = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, q = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, k = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function R(t) {
      return typeof t == "string" || typeof t == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      t === i || t === w || t === s || t === f || t === c || t === m || typeof t == "object" && t !== null && (t.$$typeof === j || t.$$typeof === g || t.$$typeof === d || t.$$typeof === p || t.$$typeof === l || t.$$typeof === $ || t.$$typeof === q || t.$$typeof === k || t.$$typeof === A);
    }
    function x(t) {
      if (typeof t == "object" && t !== null) {
        var W = t.$$typeof;
        switch (W) {
          case a:
            var V = t.type;
            switch (V) {
              case v:
              case w:
              case i:
              case s:
              case f:
              case c:
                return V;
              default:
                var ve = V && V.$$typeof;
                switch (ve) {
                  case p:
                  case l:
                  case j:
                  case g:
                  case d:
                    return ve;
                  default:
                    return W;
                }
            }
          case u:
            return W;
        }
      }
    }
    var n = v, U = w, Z = p, B = d, ee = a, re = l, H = i, te = j, ne = g, z = u, oe = s, Y = f, F = c, Q = !1;
    function ae(t) {
      return Q || (Q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), r(t) || x(t) === v;
    }
    function r(t) {
      return x(t) === w;
    }
    function o(t) {
      return x(t) === p;
    }
    function T(t) {
      return x(t) === d;
    }
    function b(t) {
      return typeof t == "object" && t !== null && t.$$typeof === a;
    }
    function y(t) {
      return x(t) === l;
    }
    function O(t) {
      return x(t) === i;
    }
    function h(t) {
      return x(t) === j;
    }
    function E(t) {
      return x(t) === g;
    }
    function S(t) {
      return x(t) === u;
    }
    function I(t) {
      return x(t) === s;
    }
    function _(t) {
      return x(t) === f;
    }
    function L(t) {
      return x(t) === c;
    }
    M.AsyncMode = n, M.ConcurrentMode = U, M.ContextConsumer = Z, M.ContextProvider = B, M.Element = ee, M.ForwardRef = re, M.Fragment = H, M.Lazy = te, M.Memo = ne, M.Portal = z, M.Profiler = oe, M.StrictMode = Y, M.Suspense = F, M.isAsyncMode = ae, M.isConcurrentMode = r, M.isContextConsumer = o, M.isContextProvider = T, M.isElement = b, M.isForwardRef = y, M.isFragment = O, M.isLazy = h, M.isMemo = E, M.isPortal = S, M.isProfiler = I, M.isStrictMode = _, M.isSuspense = L, M.isValidElementType = R, M.typeOf = x;
  })()), M;
}
var Te;
function Ae() {
  return Te || (Te = 1, process.env.NODE_ENV === "production" ? X.exports = Qe() : X.exports = Ve()), X.exports;
}
var ce, ge;
function Ke() {
  if (ge) return ce;
  ge = 1;
  var e = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function f() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var d = {}, p = 0; p < 10; p++)
        d["_" + String.fromCharCode(p)] = p;
      var v = Object.getOwnPropertyNames(d).map(function(l) {
        return d[l];
      });
      if (v.join("") !== "0123456789")
        return !1;
      var w = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        w[l] = l;
      }), Object.keys(Object.assign({}, w)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ce = f() ? Object.assign : function(s, d) {
    for (var p, v = i(s), w, l = 1; l < arguments.length; l++) {
      p = Object(arguments[l]);
      for (var c in p)
        a.call(p, c) && (v[c] = p[c]);
      if (e) {
        w = e(p);
        for (var m = 0; m < w.length; m++)
          u.call(p, w[m]) && (v[w[m]] = p[w[m]]);
      }
    }
    return v;
  }, ce;
}
var ue, Re;
function ye() {
  if (Re) return ue;
  Re = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ue = e, ue;
}
var fe, xe;
function Ie() {
  return xe || (xe = 1, fe = Function.call.bind(Object.prototype.hasOwnProperty)), fe;
}
var le, Oe;
function Je() {
  if (Oe) return le;
  Oe = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var a = /* @__PURE__ */ ye(), u = {}, i = /* @__PURE__ */ Ie();
    e = function(s) {
      var d = "Warning: " + s;
      typeof console < "u" && console.error(d);
      try {
        throw new Error(d);
      } catch {
      }
    };
  }
  function f(s, d, p, v, w) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in s)
        if (i(s, l)) {
          var c;
          try {
            if (typeof s[l] != "function") {
              var m = Error(
                (v || "React class") + ": " + p + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            c = s[l](d, l, v, p, null, a);
          } catch (j) {
            c = j;
          }
          if (c && !(c instanceof Error) && e(
            (v || "React class") + ": type specification of " + p + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in u)) {
            u[c.message] = !0;
            var g = w ? w() : "";
            e(
              "Failed " + p + " type: " + c.message + (g ?? "")
            );
          }
        }
    }
  }
  return f.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (u = {});
  }, le = f, le;
}
var de, Se;
function Xe() {
  if (Se) return de;
  Se = 1;
  var e = Ae(), a = Ke(), u = /* @__PURE__ */ ye(), i = /* @__PURE__ */ Ie(), f = /* @__PURE__ */ Je(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(p) {
    var v = "Warning: " + p;
    typeof console < "u" && console.error(v);
    try {
      throw new Error(v);
    } catch {
    }
  });
  function d() {
    return null;
  }
  return de = function(p, v) {
    var w = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function c(r) {
      var o = r && (w && r[w] || r[l]);
      if (typeof o == "function")
        return o;
    }
    var m = "<<anonymous>>", g = {
      array: q("array"),
      bigint: q("bigint"),
      bool: q("boolean"),
      func: q("function"),
      number: q("number"),
      object: q("object"),
      string: q("string"),
      symbol: q("symbol"),
      any: k(),
      arrayOf: R,
      element: x(),
      elementType: n(),
      instanceOf: U,
      node: re(),
      objectOf: B,
      oneOf: Z,
      oneOfType: ee,
      shape: te,
      exact: ne
    };
    function j(r, o) {
      return r === o ? r !== 0 || 1 / r === 1 / o : r !== r && o !== o;
    }
    function A(r, o) {
      this.message = r, this.data = o && typeof o == "object" ? o : {}, this.stack = "";
    }
    A.prototype = Error.prototype;
    function $(r) {
      if (process.env.NODE_ENV !== "production")
        var o = {}, T = 0;
      function b(O, h, E, S, I, _, L) {
        if (S = S || m, _ = _ || E, L !== u) {
          if (v) {
            var t = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw t.name = "Invariant Violation", t;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var W = S + ":" + E;
            !o[W] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + _ + "` prop on `" + S + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), o[W] = !0, T++);
          }
        }
        return h[E] == null ? O ? h[E] === null ? new A("The " + I + " `" + _ + "` is marked as required " + ("in `" + S + "`, but its value is `null`.")) : new A("The " + I + " `" + _ + "` is marked as required in " + ("`" + S + "`, but its value is `undefined`.")) : null : r(h, E, S, I, _);
      }
      var y = b.bind(null, !1);
      return y.isRequired = b.bind(null, !0), y;
    }
    function q(r) {
      function o(T, b, y, O, h, E) {
        var S = T[b], I = Y(S);
        if (I !== r) {
          var _ = F(S);
          return new A(
            "Invalid " + O + " `" + h + "` of type " + ("`" + _ + "` supplied to `" + y + "`, expected ") + ("`" + r + "`."),
            { expectedType: r }
          );
        }
        return null;
      }
      return $(o);
    }
    function k() {
      return $(d);
    }
    function R(r) {
      function o(T, b, y, O, h) {
        if (typeof r != "function")
          return new A("Property `" + h + "` of component `" + y + "` has invalid PropType notation inside arrayOf.");
        var E = T[b];
        if (!Array.isArray(E)) {
          var S = Y(E);
          return new A("Invalid " + O + " `" + h + "` of type " + ("`" + S + "` supplied to `" + y + "`, expected an array."));
        }
        for (var I = 0; I < E.length; I++) {
          var _ = r(E, I, y, O, h + "[" + I + "]", u);
          if (_ instanceof Error)
            return _;
        }
        return null;
      }
      return $(o);
    }
    function x() {
      function r(o, T, b, y, O) {
        var h = o[T];
        if (!p(h)) {
          var E = Y(h);
          return new A("Invalid " + y + " `" + O + "` of type " + ("`" + E + "` supplied to `" + b + "`, expected a single ReactElement."));
        }
        return null;
      }
      return $(r);
    }
    function n() {
      function r(o, T, b, y, O) {
        var h = o[T];
        if (!e.isValidElementType(h)) {
          var E = Y(h);
          return new A("Invalid " + y + " `" + O + "` of type " + ("`" + E + "` supplied to `" + b + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return $(r);
    }
    function U(r) {
      function o(T, b, y, O, h) {
        if (!(T[b] instanceof r)) {
          var E = r.name || m, S = ae(T[b]);
          return new A("Invalid " + O + " `" + h + "` of type " + ("`" + S + "` supplied to `" + y + "`, expected ") + ("instance of `" + E + "`."));
        }
        return null;
      }
      return $(o);
    }
    function Z(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), d;
      function o(T, b, y, O, h) {
        for (var E = T[b], S = 0; S < r.length; S++)
          if (j(E, r[S]))
            return null;
        var I = JSON.stringify(r, function(L, t) {
          var W = F(t);
          return W === "symbol" ? String(t) : t;
        });
        return new A("Invalid " + O + " `" + h + "` of value `" + String(E) + "` " + ("supplied to `" + y + "`, expected one of " + I + "."));
      }
      return $(o);
    }
    function B(r) {
      function o(T, b, y, O, h) {
        if (typeof r != "function")
          return new A("Property `" + h + "` of component `" + y + "` has invalid PropType notation inside objectOf.");
        var E = T[b], S = Y(E);
        if (S !== "object")
          return new A("Invalid " + O + " `" + h + "` of type " + ("`" + S + "` supplied to `" + y + "`, expected an object."));
        for (var I in E)
          if (i(E, I)) {
            var _ = r(E, I, y, O, h + "." + I, u);
            if (_ instanceof Error)
              return _;
          }
        return null;
      }
      return $(o);
    }
    function ee(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), d;
      for (var o = 0; o < r.length; o++) {
        var T = r[o];
        if (typeof T != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Q(T) + " at index " + o + "."
          ), d;
      }
      function b(y, O, h, E, S) {
        for (var I = [], _ = 0; _ < r.length; _++) {
          var L = r[_], t = L(y, O, h, E, S, u);
          if (t == null)
            return null;
          t.data && i(t.data, "expectedType") && I.push(t.data.expectedType);
        }
        var W = I.length > 0 ? ", expected one of type [" + I.join(", ") + "]" : "";
        return new A("Invalid " + E + " `" + S + "` supplied to " + ("`" + h + "`" + W + "."));
      }
      return $(b);
    }
    function re() {
      function r(o, T, b, y, O) {
        return z(o[T]) ? null : new A("Invalid " + y + " `" + O + "` supplied to " + ("`" + b + "`, expected a ReactNode."));
      }
      return $(r);
    }
    function H(r, o, T, b, y) {
      return new A(
        (r || "React class") + ": " + o + " type `" + T + "." + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + y + "`."
      );
    }
    function te(r) {
      function o(T, b, y, O, h) {
        var E = T[b], S = Y(E);
        if (S !== "object")
          return new A("Invalid " + O + " `" + h + "` of type `" + S + "` " + ("supplied to `" + y + "`, expected `object`."));
        for (var I in r) {
          var _ = r[I];
          if (typeof _ != "function")
            return H(y, O, h, I, F(_));
          var L = _(E, I, y, O, h + "." + I, u);
          if (L)
            return L;
        }
        return null;
      }
      return $(o);
    }
    function ne(r) {
      function o(T, b, y, O, h) {
        var E = T[b], S = Y(E);
        if (S !== "object")
          return new A("Invalid " + O + " `" + h + "` of type `" + S + "` " + ("supplied to `" + y + "`, expected `object`."));
        var I = a({}, T[b], r);
        for (var _ in I) {
          var L = r[_];
          if (i(r, _) && typeof L != "function")
            return H(y, O, h, _, F(L));
          if (!L)
            return new A(
              "Invalid " + O + " `" + h + "` key `" + _ + "` supplied to `" + y + "`.\nBad object: " + JSON.stringify(T[b], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(r), null, "  ")
            );
          var t = L(E, _, y, O, h + "." + _, u);
          if (t)
            return t;
        }
        return null;
      }
      return $(o);
    }
    function z(r) {
      switch (typeof r) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !r;
        case "object":
          if (Array.isArray(r))
            return r.every(z);
          if (r === null || p(r))
            return !0;
          var o = c(r);
          if (o) {
            var T = o.call(r), b;
            if (o !== r.entries) {
              for (; !(b = T.next()).done; )
                if (!z(b.value))
                  return !1;
            } else
              for (; !(b = T.next()).done; ) {
                var y = b.value;
                if (y && !z(y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function oe(r, o) {
      return r === "symbol" ? !0 : o ? o["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && o instanceof Symbol : !1;
    }
    function Y(r) {
      var o = typeof r;
      return Array.isArray(r) ? "array" : r instanceof RegExp ? "object" : oe(o, r) ? "symbol" : o;
    }
    function F(r) {
      if (typeof r > "u" || r === null)
        return "" + r;
      var o = Y(r);
      if (o === "object") {
        if (r instanceof Date)
          return "date";
        if (r instanceof RegExp)
          return "regexp";
      }
      return o;
    }
    function Q(r) {
      var o = F(r);
      switch (o) {
        case "array":
        case "object":
          return "an " + o;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + o;
        default:
          return o;
      }
    }
    function ae(r) {
      return !r.constructor || !r.constructor.name ? m : r.constructor.name;
    }
    return g.checkPropTypes = f, g.resetWarningCache = f.resetWarningCache, g.PropTypes = g, g;
  }, de;
}
var pe, _e;
function Ge() {
  if (_e) return pe;
  _e = 1;
  var e = /* @__PURE__ */ ye();
  function a() {
  }
  function u() {
  }
  return u.resetWarningCache = a, pe = function() {
    function i(d, p, v, w, l, c) {
      if (c !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    i.isRequired = i;
    function f() {
      return i;
    }
    var s = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: f,
      element: i,
      elementType: i,
      instanceOf: f,
      node: i,
      objectOf: f,
      oneOf: f,
      oneOfType: f,
      shape: f,
      exact: f,
      checkPropTypes: u,
      resetWarningCache: a
    };
    return s.PropTypes = s, s;
  }, pe;
}
var we;
function Ze() {
  if (we) return J.exports;
  if (we = 1, process.env.NODE_ENV !== "production") {
    var e = Ae(), a = !0;
    J.exports = /* @__PURE__ */ Xe()(e.isElement, a);
  } else
    J.exports = /* @__PURE__ */ Ge()();
  return J.exports;
}
var Be = /* @__PURE__ */ Ze();
const P = /* @__PURE__ */ Ce(Be), D = P.oneOfType([P.string, P.number]), $e = {
  all: P.bool,
  grid: P.bool,
  aural: P.bool,
  braille: P.bool,
  handheld: P.bool,
  print: P.bool,
  projection: P.bool,
  screen: P.bool,
  tty: P.bool,
  tv: P.bool,
  embossed: P.bool
}, er = {
  orientation: P.oneOf(["portrait", "landscape"]),
  scan: P.oneOf(["progressive", "interlace"]),
  aspectRatio: P.string,
  deviceAspectRatio: P.string,
  height: D,
  deviceHeight: D,
  width: D,
  deviceWidth: D,
  color: P.bool,
  colorIndex: P.bool,
  monochrome: P.bool,
  resolution: D,
  type: Object.keys($e)
}, { type: hr, ...rr } = er, tr = {
  minAspectRatio: P.string,
  maxAspectRatio: P.string,
  minDeviceAspectRatio: P.string,
  maxDeviceAspectRatio: P.string,
  minHeight: D,
  maxHeight: D,
  minDeviceHeight: D,
  maxDeviceHeight: D,
  minWidth: D,
  maxWidth: D,
  minDeviceWidth: D,
  maxDeviceWidth: D,
  minColor: P.number,
  maxColor: P.number,
  minColorIndex: P.number,
  maxColorIndex: P.number,
  minMonochrome: P.number,
  maxMonochrome: P.number,
  minResolution: D,
  maxResolution: D,
  ...rr
}, nr = { ...$e, ...tr };
var or = {
  all: nr
};
const ar = (e) => `not ${e}`, ir = (e, a) => {
  const u = Me(e);
  return typeof a == "number" && (a = `${a}px`), a === !0 ? u : a === !1 ? ar(u) : `(${u}: ${a})`;
}, sr = (e) => e.join(" and "), cr = (e) => {
  const a = [];
  return Object.keys(or.all).forEach((u) => {
    const i = e[u];
    i != null && a.push(ir(u, i));
  }), sr(a);
}, ur = Le(void 0), fr = (e) => e.query || cr(e), Pe = (e) => e ? Object.keys(e).reduce((u, i) => (u[Me(i)] = e[i], u), {}) : void 0, je = () => {
  const e = De(!1);
  return N(() => {
    e.current = !0;
  }, []), e.current;
}, lr = (e) => {
  const a = qe(ur), u = () => Pe(e) || Pe(a), [i, f] = G(u);
  return N(() => {
    const s = u();
    He(i, s) || f(s);
  }, [e, a]), i;
}, dr = (e) => {
  const a = () => fr(e), [u, i] = G(a);
  return N(() => {
    const f = a();
    u !== f && i(f);
  }, [e]), u;
}, pr = (e, a) => {
  const u = () => Ue(e, a || {}, !!a), [i, f] = G(u), s = je();
  return N(() => {
    if (s) {
      const d = u();
      return f(d), () => {
        d && d.dispose();
      };
    }
  }, [e, a]), i;
}, yr = (e) => {
  const [a, u] = G(e.matches);
  return N(() => {
    const i = (f) => {
      u(f.matches);
    };
    return e.addListener(i), u(e.matches), () => {
      e.removeListener(i);
    };
  }, [e]), a;
}, br = (e, a, u) => {
  const i = lr(a), f = dr(e);
  if (!f)
    throw new Error("Invalid or missing MediaQuery!");
  const s = pr(f, i), d = yr(s);
  return je(), N(() => {
  }, [d]), N(() => () => {
    s && s.dispose();
  }, []), d;
};
export {
  br as u
};
